import React, { useEffect } from "react";
import { RouterProvider, createBrowserRouter, Navigate } from "react-router-dom";
import WebFont from "webfontloader";
import { LandingPage, NotFoundPage } from "./pages";
import "./App.scss";

const router = createBrowserRouter([
  { path: "/deeplink/health", element: <>ok</> },
  { path: "/deeplink", element: <LandingPage /> },
  { path: "/deeplink/error", element: <NotFoundPage /> },
  { path: "*",  element:<Navigate to="/deeplink/error" replace /> },
]);

const App = () => {
  useEffect(() => {
    WebFont.load({ google: { families: ["Poppins", "Inter"] } });
  }, []);
  return <RouterProvider router={router} />;
};

export default App;
